export const TO_STATUS = {
  OPENED: 1
}
